interface Props {
  className?: string;
  bgColor?: string;
  logoColor?: string;
}

export function NewSynclyLogo(props: Props) {
  const { bgColor = 'var(--color-rebranding-600)', logoColor = 'var(--color-primary)' } = props;

  return (
    <svg
      className={props.className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z"
        fill={bgColor}
      />
      <path
        d="M15.3496 12.321C15.9193 11.6688 16.9113 11.6052 17.5596 12.1794L19.7148 14.0886C19.7735 14.138 19.8316 14.191 19.8916 14.2448L20.0488 14.3845H20.0469C20.4326 14.751 20.8227 15.2044 21.1064 15.7321L21.1045 15.7331C22.7677 18.8274 21.6314 22.6725 18.5654 24.321C15.4993 25.9689 11.6636 24.7968 10 21.7028L12.7773 20.2097C13.6092 21.7563 15.5266 22.3429 17.0596 21.5192C18.5925 20.695 19.1605 18.7724 18.3291 17.2253H18.3301C18.1112 16.842 17.779 16.5013 17.4082 16.1628L15.5088 14.5319C14.8511 13.9672 14.7794 12.9739 15.3496 12.321ZM13.4365 7.67938C16.5027 6.0313 20.3374 7.2025 22.001 10.2966L19.2236 11.7888L19.1426 11.6462C18.2724 10.2067 16.4263 9.68141 14.9414 10.4792C13.4089 11.3034 12.84 13.2262 13.6709 14.7731V14.7741L13.7822 14.9665C13.8937 15.1425 14.0213 15.3022 14.167 15.4557L16.6465 17.5651C17.3102 18.1295 17.3846 19.1276 16.8115 19.7839C16.2442 20.4334 15.2577 20.5008 14.6074 19.9343L12.0088 17.6706L12.0098 17.6686C11.6308 17.3422 11.2339 16.8975 10.8945 16.2663L10.8955 16.2653C9.23292 13.1711 10.3707 9.32774 13.4365 7.67938Z"
        fill={logoColor}
      />
    </svg>
  );
}
